import React from 'react'
import Platforms from '../components/Plaforms'
import enginneringVideo from '../assets/Services/engineering_platforms.mp4'
import intelligenceAutomationVideo from '../assets/Services/intelligence_automation.mp4'
import growthvisibilityVideo from '../assets/Services/growth_visibility.mp4'
import designExperienceVideo from '../assets/Services/design_experience.mp4'
import connectedSystemsVideo from '../assets/Services/connected_systems.mp4'
import { useLocation } from 'react-router-dom'


// import images  for Engineering
import webdevelopment01 from '../assets/Services/engineering&platforms/web01.avif'
import webdevelopment02 from '../assets/Services/engineering&platforms/web06.avif'
import webdevelopment03 from '../assets/Services/engineering&platforms/web03.avif'
import webdevelopment04 from '../assets/Services/engineering&platforms/web08.avif'

import mobileApp01 from '../assets/Services/engineering&platforms/MobileApp-01.avif'
import mobileApp02 from '../assets/Services/engineering&platforms/MobileApp-02.avif'
import mobileApp03 from '../assets/Services/engineering&platforms/MobileApp-03.avif'
import mobileApp04 from '../assets/Services/engineering&platforms/MobileApp-04.avif'

import ProductDev01 from '../assets/Services/engineering&platforms/ProductDev-01.avif'
import ProductDev02 from '../assets/Services/engineering&platforms/ProductDev-02.avif'
import ProductDev03 from '../assets/Services/engineering&platforms/ProductDev-03.avif'
import ProductDev04 from '../assets/Services/engineering&platforms/ProductDev-04.avif'

import Enterprise01 from '../assets/Services/engineering&platforms/Enterprise-01.avif'
import Enterprise02 from '../assets/Services/engineering&platforms/Enterprise-02.avif'
import Enterprise03 from '../assets/Services/engineering&platforms/Enterprise-03.avif'
import Enterprise04 from '../assets/Services/engineering&platforms/Enterprise-04.avif'

// Import image for Intellinece& automation

import ai01 from '../assets/Services/AI&ML/AI-01.avif'
import ai02 from '../assets/Services/AI&ML/AI-02.avif'
import ai03 from '../assets/Services/AI&ML/AI-03.avif'
import ai04 from '../assets/Services/AI&ML/AI-04.avif'

import intelligent01 from '../assets/Services/AI&ML/Intelligent-01.avif'
import intelligent02 from '../assets/Services/AI&ML/Intelligent-02.avif'
import intelligent03 from '../assets/Services/AI&ML/Intelligent-03.avif'
import intelligent04 from '../assets/Services/AI&ML/Intelligent-04.avif'

import dataAnalytics01 from '../assets/Services/AI&ML/DataAnalytics-01.avif'
import dataAnalytics02 from '../assets/Services/AI&ML/DataAnalytics-02.avif'
import dataAnalytics03 from '../assets/Services/AI&ML/DataAnalytics-03.avif'
import dataAnalytics04 from '../assets/Services/AI&ML/DataAnalytics-04.avif'

import business01 from '../assets/Services/AI&ML/BusinessIntelligent-01.avif'
import business02 from '../assets/Services/AI&ML/BusinessIntelligent-02.avif'
import business03 from '../assets/Services/AI&ML/BusinessIntelligent-03.avif'
import business04 from '../assets/Services/AI&ML/BusinessIntelligent-04.avif'

// Import image for Design & experience

import ui01 from '../assets/Services/Design/ui-01.avif'
import ui02 from '../assets/Services/Design/ui-02.avif'
import ui03 from '../assets/Services/Design/ui-03.avif'
import ui04 from '../assets/Services/Design/ui-04.avif'

import design01 from '../assets/Services/Design/design-01.avif'
import design02 from '../assets/Services/Design/design-02.avif'
import design03 from '../assets/Services/Design/design-03.avif'
import design04 from '../assets/Services/Design/design-04.avif'

import brand01 from '../assets/Services/Design/brand-01.avif'
import brand02 from '../assets/Services/Design/brand-02.avif'
import brand03 from '../assets/Services/Design/brand-03.avif'
import brand04 from '../assets/Services/Design/brand-04.avif'

import digital01 from '../assets/Services/Design/digital-01.avif'
import digital02 from '../assets/Services/Design/digital-02.avif'
import digital03 from '../assets/Services/Design/digital-03.avif'
import digital04 from '../assets/Services/Design/digital-04.avif'

// Import or Growth Analytics
import digitalMarket01 from '../assets/Services/GrowthAnalytics/digitalMarket-01.avif'
import digitalMarket02 from '../assets/Services/GrowthAnalytics/digitalMarket-02.avif'
import digitalMarket03 from '../assets/Services/GrowthAnalytics/digitalMarket-03.avif'
import digitalMarket04 from '../assets/Services/GrowthAnalytics/digitalMarket-04.avif'

import seo01 from '../assets/Services/GrowthAnalytics/seo-1.avif'
import seo02 from '../assets/Services/GrowthAnalytics/seo-2.avif'
import seo03 from '../assets/Services/GrowthAnalytics/seo-3.avif'
import seo04 from '../assets/Services/GrowthAnalytics/seo-4.avif'

import performance01 from '../assets/Services/GrowthAnalytics/performance-01.avif'
import performance02 from '../assets/Services/GrowthAnalytics/performance-02.avif'
import performance03 from '../assets/Services/GrowthAnalytics/performance-03.avif'
import performance04 from '../assets/Services/GrowthAnalytics/performance-04.avif'

import growth01 from '../assets/Services/GrowthAnalytics/growth-01.avif'
import growth02 from '../assets/Services/GrowthAnalytics/growth-02.avif'
import growth03 from '../assets/Services/GrowthAnalytics/growth-03.avif'
import growth04 from '../assets/Services/GrowthAnalytics/growth-04.avif'

// Import for the connected system
import iots01 from '../assets/Services/iot/connect-01.avif'
import iots02 from '../assets/Services/iot/connect-02.avif'
import iots03 from '../assets/Services/iot/connect-03.avif'
import iots04 from '../assets/Services/iot/connect-04.avif'

import hardware01 from '../assets/Services/iot/hardware-01.avif'
import hardware02 from '../assets/Services/iot/hardware-02.avif'
import hardware03 from '../assets/Services/iot/hardware-03.avif'
import hardware04 from '../assets/Services/iot/hardware-04.avif'

import monitor01 from '../assets/Services/iot/monitor-01.avif'
import monitor02 from '../assets/Services/iot/monitor-02.avif'
import monitor03 from '../assets/Services/iot/monitor-03.avif'
import monitor04 from '../assets/Services/iot/monitor-04.avif'

import smartDevice01 from '../assets/Services/iot/smart-01.avif'
import smartDevice02 from '../assets/Services/iot/smart-02.avif'
import smartDevice03 from '../assets/Services/iot/smart-03.avif'
import smartDevice04 from '../assets/Services/iot/smart-04.avif'


export default function Services() {
  const location = useLocation()
  const sectionId = decodeURIComponent(location.hash.replace("#", ""));
  const query = new URLSearchParams(location.search)
  const titleId = decodeURIComponent(
    query.get("title") || ""
  );


  

  const industries = [
    {
      id: "engineering-platforms",

      title: "Engineering & Platforms",

      video: enginneringVideo,

      description:
        "We build scalable engineering systems and digital platforms designed to improve operational efficiency, automate workflows, and support long-term business growth.",

      services: [
        {
          number: "01",

          title: "Web Development",

          description:
            "We create high-performance websites and web applications tailored for business operations, customer engagement, and scalable digital growth.",

          features: [
            {
              title: "Custom Websites",

              description:
                "Every engagement is treated like a product, focused on long-term value and scale.",
            },

            {
              title: "Enterprise Applications",

              description:
                "Systems are built with performance, reliability, and security as fundamentals.",
            },

            {
              title: "CMS Solutions",

              description:
                "AI and automation are applied deliberately to deliver measurable business outcomes.",
            },

            {
              title: "Frontend Experiences",

              description:
                "Our platforms grow with business needs and evolving technology.",
            },

            {
              title: "Backend Systems",

              description:
                "We work as an extension of your team, beyond simple execution.",
            },
          ],
          images: [webdevelopment01, webdevelopment02, webdevelopment03, webdevelopment04]
        },

        {
          number: "02",

          title: "Mobile Application Development",

          description:
            "We develop secure, scalable, and user-focused mobile applications for Android and iOS platforms, helping businesses streamline operations, enhance customer engagement, and accelerate digital transformation through modern mobile technologies.",

          features: [
            {
              title: "Android & iOS Applications",

              description:
                "Professional mobile applications are developed for Android and iOS platforms to deliver seamless user experiences across devices.",
            },

            {
              title: "Custom Business Applications",

              description:
                "Mobile solutions are tailored to business operations, helping organizations improve productivity, customer engagement, and digital accessibility.",
            },

            {
              title: "Secure & Scalable Development",

              description:
                "Applications are built with secure architectures and scalable technologies to support long-term business growth and performance.",
            },

            {
              title: "User-Centric Mobile Experiences",

              description:
                "Modern UI/UX practices are applied to create intuitive, responsive, and engaging mobile experiences for end users.",
            },

            {
              title: "API & System Integration",

              description:
                "Mobile applications are integrated with APIs, cloud services, and enterprise platforms to ensure smooth connectivity and real-time operations.",
            },
          ],
          images: [mobileApp01, mobileApp02, mobileApp03, mobileApp04]

        },
        {
          number: "03",

          title: "Product Development",

          description:
            "We design and develop scalable digital products tailored to business goals, combining modern technologies, intuitive user experiences, and agile development practices to accelerate innovation and market readiness.",

          features: [
            {
              title: "Custom Product Engineering",

              description:
                "End-to-end product development services are delivered to transform ideas into reliable and market-ready digital solutions.",
            },

            {
              title: "Scalable Architecture",

              description:
                "Products are built with flexible and scalable architectures to support future enhancements, integrations, and growing user demands.",
            },

            {
              title: "Agile Development Process",

              description:
                "Agile methodologies are followed to ensure faster development cycles, continuous improvements, and efficient project delivery.",
            },

            {
              title: "User-Focused Experiences",

              description:
                "Modern UI/UX strategies are implemented to create engaging, intuitive, and customer-centric digital product experiences.",
            },

            {
              title: "Cloud & API Integration",

              description:
                "Products are integrated with cloud platforms, APIs, and third-party services to ensure seamless functionality and connectivity.",
            },
          ],
          images: [ProductDev01, ProductDev02, ProductDev03, ProductDev04]

        },
        {
          number: "04",

          title: "Enterprise Systems",

          description:
            "We develop enterprise-grade systems that streamline business operations, improve organizational efficiency, and support secure digital transformation across departments and business processes.",

          features: [
            {
              title: "Business Process Automation",

              description:
                "Enterprise solutions are designed to automate workflows, reduce manual operations, and improve organizational productivity.",
            },

            {
              title: "ERP & Management Systems",

              description:
                "Integrated enterprise platforms are developed to manage operations, resources, reporting, and business activities efficiently.",
            },

            {
              title: "Secure Enterprise Architecture",

              description:
                "Systems are built with enterprise-level security, scalability, and reliability to support critical business operations.",
            },

            {
              title: "Data & System Integration",

              description:
                "Enterprise applications are integrated with existing platforms, databases, and third-party services for seamless operations.",
            },

            {
              title: "Real-Time Analytics & Reporting",

              description:
                "Advanced dashboards and reporting tools provide real-time insights to support informed business decisions and performance tracking.",
            },
          ],
          images: [Enterprise01, Enterprise02, Enterprise03, Enterprise04]

        },
      ],
    },

    {
      id: "intelligence-automation",

      title: "Intelligence & Automation",

      video: intelligenceAutomationVideo,

      description:
        "We help organizations harness the power of artificial intelligence, automation, and data-driven insights to optimize operations, improve decision-making, and accelerate business transformation. Our solutions combine intelligent technologies with scalable platforms to drive efficiency, innovation, and measurable business outcomes.",

      services: [
        {
          number: "01",

          title: "AI & Machine Learning",

          description:
            "We develop AI-powered solutions that enable businesses to automate processes, uncover insights, and make smarter decisions through advanced machine learning technologies.",

          features: [
            {
              title: "Predictive Intelligence",

              description:
                "Machine learning models are designed to forecast trends, identify opportunities, and support proactive business decisions.",
            },

            {
              title: "AI-Powered Applications",

              description:
                "Intelligent capabilities are integrated into business applications to enhance efficiency, accuracy, and user experiences.",
            },

            {
              title: "Natural Language Processing",

              description:
                "AI solutions are developed to understand, process, and analyze human language for smarter interactions and automation.",
            },

            {
              title: "Computer Vision Solutions",

              description:
                "Advanced image and video analysis technologies enable automated recognition, monitoring, and decision-making processes.",
            },

            {
              title: "Intelligent Decision Support",

              description:
                "AI-driven systems provide actionable insights that help organizations improve operational and strategic outcomes.",
            },
          ],
          images: [ai01, ai02, ai03, ai04]

        },

        {
          number: "02",

          title: "Intelligent Automation",

          description:
            "We implement automation solutions that streamline workflows, eliminate repetitive tasks, and improve productivity across business operations.",

          features: [
            {
              title: "Workflow Automation",

              description:
                "Business processes are automated to improve efficiency, consistency, and operational performance.",
            },

            {
              title: "Process Optimization",

              description:
                "Automation strategies are applied to reduce manual effort and accelerate critical business activities.",
            },

            {
              title: "Digital Operations",

              description:
                "Intelligent systems enable seamless execution and monitoring of day-to-day business operations.",
            },

            {
              title: "Automated Data Processing",

              description:
                "Data collection, validation, and processing tasks are automated to improve speed and accuracy.",
            },

            {
              title: "Scalable Automation Frameworks",

              description:
                "Automation platforms are designed to support evolving business requirements and future growth.",
            },
          ],
          images: [intelligent01, intelligent02, intelligent03, intelligent04]

        },

        {
          number: "03",

          title: "Data & Analytics",

          description:
            "We transform business data into meaningful insights through advanced analytics, enabling organizations to make informed and strategic decisions.",

          features: [
            {
              title: "Data Management",

              description:
                "Structured and unstructured data is organized to improve accessibility, quality, and governance.",
            },

            {
              title: "Advanced Analytics",

              description:
                "Analytical models are developed to identify patterns, trends, and opportunities across business operations.",
            },

            {
              title: "Performance Monitoring",

              description:
                "Key metrics and business indicators are tracked to support continuous improvement initiatives.",
            },

            {
              title: "Real-Time Insights",

              description:
                "Organizations gain timely access to operational and business intelligence for faster decision-making.",
            },

            {
              title: "Data-Driven Strategy",

              description:
                "Analytics solutions provide the foundation for informed planning, optimization, and growth.",
            },
          ],
          images: [dataAnalytics01, dataAnalytics02, dataAnalytics03, dataAnalytics04]

        },

        {
          number: "04",

          title: "Business Intelligence Systems",

          description:
            "We develop business intelligence platforms that provide comprehensive visibility into organizational performance through interactive dashboards and reporting solutions.",

          features: [
            {
              title: "Executive Dashboards",

              description:
                "Interactive dashboards provide clear visibility into key business metrics and performance indicators.",
            },

            {
              title: "Custom Reporting",

              description:
                "Tailored reporting solutions deliver actionable insights aligned with business objectives.",
            },

            {
              title: "Operational Intelligence",

              description:
                "Real-time monitoring capabilities help organizations track performance and respond quickly to changes.",
            },

            {
              title: "Data Visualization",

              description:
                "Complex business data is transformed into intuitive visual insights that support informed decision-making.",
            },

            {
              title: "Enterprise Intelligence",

              description:
                "Unified intelligence platforms consolidate data from multiple sources to provide a complete business view.",
            },
          ],
          images: [business01, business02, business03, business04]

        },
      ],
    },

    {
      id: "design-experience",

      title: "Design & Experience",

      video: designExperienceVideo,

      description:
        "We create impactful digital experiences that combine user-centered design, strategic thinking, and strong brand systems. Our solutions help businesses deliver intuitive interactions, strengthen brand presence, and build meaningful customer relationships across digital platforms.",

      services: [
        {
          number: "01",

          title: "UI / UX Design",

          description:
            "We design intuitive, accessible, and visually engaging user experiences that enhance customer satisfaction, improve usability, and drive business outcomes across web and mobile platforms.",

          features: [
            {
              title: "User Interface Design",

              description:
                "Modern and visually engaging interfaces are crafted to align with user expectations and business objectives.",
            },

            {
              title: "User Experience Design",

              description:
                "User journeys are designed to deliver seamless interactions, improved usability, and enhanced customer satisfaction.",
            },

            {
              title: "Wireframing & Prototyping",

              description:
                "Interactive prototypes and wireframes help validate concepts and optimize user experiences before development.",
            },

            {
              title: "Responsive Design",

              description:
                "Digital interfaces are optimized to provide consistent experiences across desktop, tablet, and mobile devices.",
            },

            {
              title: "Accessibility & Usability",

              description:
                "Design solutions follow usability best practices to create inclusive and efficient user experiences.",
            },
          ],
          images: [ui01, ui02, ui03, ui04]

        },

        {
          number: "02",

          title: "Design Strategy",

          description:
            "We align design initiatives with business goals through research, planning, and strategic frameworks that support long-term growth and digital success.",

          features: [
            {
              title: "User Research",

              description:
                "Research-driven insights help identify customer needs, behaviors, and opportunities for innovation.",
            },

            {
              title: "Experience Planning",

              description:
                "Strategic roadmaps are developed to create consistent and effective customer experiences.",
            },

            {
              title: "Customer-Centric Design",

              description:
                "Design decisions are guided by user expectations to maximize engagement and satisfaction.",
            },

            {
              title: "Design Governance",

              description:
                "Structured design standards ensure consistency, quality, and scalability across digital products.",
            },

            {
              title: "Innovation & Growth Strategy",

              description:
                "Design approaches are aligned with business objectives to support continuous improvement and innovation.",
            },
          ],
          images: [design01, design02, design03, design04]
        },

        {
          number: "03",

          title: "Brand Systems",

          description:
            "We develop scalable brand systems that create consistency across digital experiences, strengthen brand identity, and improve customer recognition.",

          features: [
            {
              title: "Brand Identity Systems",

              description:
                "Comprehensive visual systems are created to establish a strong and recognizable brand presence.",
            },

            {
              title: "Design Standards",

              description:
                "Clear guidelines ensure consistent application of brand elements across digital platforms.",
            },

            {
              title: "Visual Language Development",

              description:
                "Unified design principles help communicate brand values through cohesive visual experiences.",
            },

            {
              title: "Digital Brand Consistency",

              description:
                "Brand assets are aligned across websites, applications, and customer touchpoints.",
            },

            {
              title: "Scalable Design Components",

              description:
                "Reusable design assets support efficient growth while maintaining brand integrity.",
            },
          ],
          images: [brand01, brand02, brand03, brand04]
        },

        {
          number: "04",

          title: "Digital Experience Design",

          description:
            "We design connected digital experiences that improve customer engagement, strengthen brand interactions, and deliver seamless journeys across websites, applications, and digital ecosystems.",

          features: [
            {
              title: "Customer Journey Design",

              description:
                "End-to-end digital journeys are designed to create meaningful interactions and improve customer satisfaction.",
            },

            {
              title: "Omnichannel Experiences",

              description:
                "Consistent experiences are delivered across web, mobile, and digital touchpoints to enhance engagement.",
            },

            {
              title: "Interaction Design",

              description:
                "Thoughtful user interactions and workflows are crafted to improve usability and overall experience quality.",
            },

            {
              title: "Experience Optimization",

              description:
                "Digital experiences are continuously refined through user insights, analytics, and performance evaluation.",
            },

            {
              title: "Engagement & Retention Strategies",

              description:
                "Experience-driven solutions are designed to increase customer engagement, loyalty, and long-term business value.",
            },
          ],
          images: [digital01, digital02, digital03, digital04]
        },
      ],
    },

    {
      id: "growth-visibility",

      title: "Growth & Visibility",

      video: growthvisibilityVideo,

      description:
        "We help businesses expand their digital presence, attract the right audiences, and achieve measurable growth through data-driven marketing strategies, performance optimization, and advanced analytics. Our solutions focus on increasing visibility, engagement, and long-term business success.",

      services: [
        {
          number: "01",

          title: "Digital Marketing",

          description:
            "We develop and execute digital marketing strategies that strengthen brand awareness, increase audience engagement, and drive sustainable business growth across digital channels.",

          features: [
            {
              title: "Content Marketing",

              description:
                "Strategic content initiatives are developed to attract, engage, and retain target audiences.",
            },

            {
              title: "Social Media Marketing",

              description:
                "Brand visibility and customer engagement are enhanced through effective social media campaigns.",
            },

            {
              title: "Campaign Management",

              description:
                "Digital campaigns are planned, executed, and optimized to maximize reach and marketing effectiveness.",
            },

            {
              title: "Audience Engagement",

              description:
                "Marketing strategies are designed to build meaningful relationships and strengthen customer connections.",
            },

            {
              title: "Digital Brand Promotion",

              description:
                "Integrated marketing efforts help organizations increase awareness and strengthen their online presence.",
            },
          ],
          images: [digitalMarket01, digitalMarket02, digitalMarket03, digitalMarket04]
        },

        {
          number: "02",

          title: "Performance Marketing",

          description:
            "We implement performance-driven marketing strategies focused on measurable outcomes, helping businesses maximize return on investment and achieve growth objectives.",

          features: [
            {
              title: "Paid Advertising",

              description:
                "Targeted advertising campaigns are optimized to generate qualified leads and improve conversion rates.",
            },

            {
              title: "Conversion Optimization",

              description:
                "Marketing funnels are refined to improve customer acquisition and business performance.",
            },

            {
              title: "Campaign Analytics",

              description:
                "Performance metrics are continuously monitored to enhance effectiveness and maximize results.",
            },

            {
              title: "Customer Acquisition",

              description:
                "Data-driven strategies are implemented to attract high-value customers and accelerate growth.",
            },

            {
              title: "ROI-Focused Marketing",

              description:
                "Marketing investments are aligned with business goals to deliver measurable and sustainable outcomes.",
            },
          ],
          images: [performance01, performance02, performance03, performance04]
        },

        {
          number: "03",

          title: "Search Engine Optimization (SEO)",

          description:
            "We improve search visibility and organic reach through strategic SEO practices that help businesses attract relevant traffic and increase online discoverability.",

          features: [
            {
              title: "Technical SEO",

              description:
                "Website structures and technical elements are optimized to improve search engine performance.",
            },

            {
              title: "On-Page Optimization",

              description:
                "Content, metadata, and site architecture are enhanced to improve rankings and user experience.",
            },

            {
              title: "Keyword Strategy",

              description:
                "Targeted keyword research helps align content with audience intent and search demand.",
            },

            {
              title: "Content Optimization",

              description:
                "Search-focused content strategies improve visibility, relevance, and audience engagement.",
            },

            {
              title: "Organic Growth Monitoring",

              description:
                "Performance is tracked continuously to identify opportunities and support long-term growth.",
            },
          ],
          images: [seo01, seo02, seo03, seo04]
        },

        {
          number: "04",

          title: "Growth Analytics",

          description:
            "We transform marketing and business data into actionable insights that support strategic decision-making, performance improvement, and sustainable growth.",

          features: [
            {
              title: "Marketing Analytics",

              description:
                "Comprehensive data analysis provides visibility into campaign performance and customer behavior.",
            },

            {
              title: "Performance Dashboards",

              description:
                "Interactive dashboards deliver real-time insights into key business and marketing metrics.",
            },

            {
              title: "Customer Insights",

              description:
                "Behavioral data is analyzed to better understand audience needs and engagement patterns.",
            },

            {
              title: "Growth Measurement",

              description:
                "Key performance indicators are tracked to evaluate success and identify optimization opportunities.",
            },

            {
              title: "Data-Driven Decision Making",

              description:
                "Actionable insights enable organizations to make informed decisions and accelerate business growth.",
            },
          ],
          images: [growth01, growth02, growth03, growth04]
        },
      ],
    },

    {
      id: "connected-systems",

      title: "Connected Systems",

      video: connectedSystemsVideo,

      description:
        "We develop connected technology solutions that bridge hardware, software, and intelligent systems to enable real-time monitoring, automation, and operational efficiency. Our connected platforms help organizations gain greater visibility, control, and insight across devices, assets, and business processes.",

      services: [
        {
          number: "01",

          title: "IoT Solutions",

          description:
            "We design and implement Internet of Things (IoT) solutions that connect devices, collect real-time data, and enable smarter business operations through intelligent connectivity.",

          features: [
            {
              title: "Device Connectivity",

              description:
                "IoT ecosystems are developed to connect sensors, devices, and systems for seamless communication and data exchange.",
            },

            {
              title: "Real-Time Data Collection",

              description:
                "Connected devices continuously capture and transmit operational data for improved visibility and decision-making.",
            },

            {
              title: "IoT Platform Development",

              description:
                "Scalable IoT platforms are built to manage devices, process data, and support enterprise growth.",
            },

            {
              title: "Remote Device Management",

              description:
                "Organizations can monitor, configure, and manage connected devices from centralized platforms.",
            },

            {
              title: "Intelligent Automation",

              description:
                "IoT-enabled workflows automate operations and improve efficiency through real-time actions and insights.",
            },
          ],
          images: [iots01, iots02, iots03, iots04]
        },

        {
          number: "02",

          title: "Hardware Integration",

          description:
            "We integrate hardware components with digital systems to create reliable, connected environments that support automation, monitoring, and business operations.",

          features: [
            {
              title: "Sensor Integration",

              description:
                "Sensors are integrated with applications and platforms to capture accurate real-time operational data.",
            },

            {
              title: "Embedded System Connectivity",

              description:
                "Hardware devices are connected with software platforms to enable seamless communication and control.",
            },

            {
              title: "Industrial Device Integration",

              description:
                "Business and industrial equipment are integrated into centralized digital ecosystems for improved efficiency.",
            },

            {
              title: "Communication Protocol Support",

              description:
                "Solutions support industry-standard communication protocols to ensure interoperability across devices.",
            },

            {
              title: "System Compatibility",

              description:
                "Hardware and software environments are aligned to ensure reliable performance and long-term scalability.",
            },
          ],
          images: [hardware01, hardware02, hardware03, hardware04]
        },

        {
          number: "03",

          title: "Monitoring & Control Systems",

          description:
            "We build intelligent monitoring and control solutions that provide real-time visibility, automated responses, and centralized management of critical operations.",

          features: [
            {
              title: "Real-Time Monitoring",

              description:
                "Operational data is continuously monitored to provide instant visibility into system performance and status.",
            },

            {
              title: "Centralized Control",

              description:
                "Control platforms enable organizations to manage connected systems from a single interface.",
            },

            {
              title: "Alerts & Notifications",

              description:
                "Automated alerts help teams respond quickly to critical events, anomalies, and operational changes.",
            },

            {
              title: "Performance Tracking",

              description:
                "System metrics are analyzed to improve reliability, efficiency, and operational effectiveness.",
            },

            {
              title: "Remote Operations Management",

              description:
                "Organizations can monitor and control assets remotely to improve responsiveness and reduce downtime.",
            },
          ],
          images: [monitor01, monitor02, monitor03, monitor04]
        },

        {
          number: "04",

          title: "Smart Device Platforms",

          description:
            "We develop smart device platforms that enable connected products, intelligent automation, and seamless interactions between devices, users, and business systems.",

          features: [
            {
              title: "Connected Device Ecosystems",

              description:
                "Platforms are designed to manage and coordinate interactions between multiple smart devices and systems.",
            },

            {
              title: "Connected Device Ecosystemst",

              description:
                "Comprehensive tools enable secure onboarding, configuration, and lifecycle management of connected devices.",
            },

            {
              title: "Smart Automation",

              description:
                "Intelligent rules and workflows enable automated actions based on real-time device data and events.",
            },

            {
              title: "Cloud Connectivity",

              description:
                "Devices are securely connected to cloud platforms for data storage, analytics, and remote access.",
            },

            {
              title: "Scalable Smart Solutions",

              description:
                "Platforms are built to support growing device networks, evolving business requirements, and future innovation.",
            },
          ],
          images: [smartDevice01, smartDevice02, smartDevice03, smartDevice04]
        },
      ],
    }

  ]

  const currentService = industries.find(industry => industry.title === sectionId)
  const currentTitle = currentService?.services?.find(
    service => service.title === titleId
  );


  return (
    <>
      <Platforms service={currentService} subservice={ currentTitle} />

    </>
  )
}
